"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerInfo = void 0;
const lodash_1 = __importDefault(require("lodash"));
const getCustomerInfo = (customer) => {
    if (!lodash_1.default.isEmpty(customer.first_name) && !lodash_1.default.isEmpty(customer.last_name)) {
        return `${customer.first_name.trim()} ${customer.last_name.trim()} (${customer.email.trim()})`;
    }
    else if (!lodash_1.default.isEmpty(customer.first_name)) {
        return `${customer.first_name.trim()} (${customer.email.trim()})`;
    }
    else if (!lodash_1.default.isEmpty(customer.last_name)) {
        return `${customer.last_name.trim()} (${customer.email.trim()})`;
    }
    else {
        return customer.email.trim();
    }
};
exports.getCustomerInfo = getCustomerInfo;
//# sourceMappingURL=get-customer-info.js.map